export default "__VITE_ASSET__DwxBI6re__"